/**
 * The signing page's countdown. A challenge lives five minutes, short enough
 * that minutes and seconds are the useful reading ("4:05"), unlike the CLI
 * page's ten-minute codes. Expiry itself is the CLI page's rule, reused: an
 * unreadable timestamp counts as expired, so the page never offers to sign
 * something it cannot vouch for.
 */
export { hasExpired, msUntil } from "pages/Members/CliApproval/expiry";

/** "4:05" for the time left; "0:00" once it is gone. */
export const clockLabel = (msLeft: number): string => {
  const totalSeconds = Math.max(0, Math.ceil(msLeft / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};
